import {Component} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {addSentryErrorLog, LocalizationService} from '@npck/libs/commons';
import {appApplyTheme, UI_KIT_LIGHT} from '@npck/libs/ui-kit';

@Component({
    selector: 'auth-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent {

    constructor(
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private localizationService: LocalizationService,
    ) {
        addSentryErrorLog('AppComponent init started');
        this.localizationService.defaultInitialization();
        appApplyTheme(UI_KIT_LIGHT);
        this.matIconRegistry.addSvgIconSet(this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/temp-cached/sprites/sprite-defs.svg`));
        addSentryErrorLog('AppComponent init finished');
    }
}
